export default __webpack_public_path__ + "static/media/Management.c433a99c.svg";